// extracted by mini-css-extract-plugin
export var root = "szM1";
export var rootImg = "scDt";
export var rootPlay = "m+Vt";
export var rootPlayIcon = "hxWQ";